import { render, staticRenderFns } from "./addMonedero.vue?vue&type=template&id=273e0a5c"
import script from "./addMonedero.vue?vue&type=script&setup=true&lang=js"
export * from "./addMonedero.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports